import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './hooks/useAuth';
import theme from './theme';

// Components
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import AgentDashboard from './pages/AgentDashboard';
import LeadForm from './pages/LeadForm';
import PayoutDashboard from './pages/PayoutDashboard';
import CreateSubAgent from './pages/CreateSubAgent';
import ContactUs from './pages/ContactUs';
import WhyJoinUs from './pages/WhyJoinUs';
import About from './pages/About';
import Resources from './pages/Resources';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Blog from './pages/Blog';
import Funds from './pages/Funds';
import PendingApproval from './pages/PendingApproval';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Calculator from './pages/Calculator';
import Products from './pages/Products';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ChakraProvider theme={theme}>
          <Router>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/why-join-us" element={<WhyJoinUs />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/pending-approval" element={<PendingApproval />} />
              <Route
                path="/admin/*"
                element={
                  <PrivateRoute role="admin">
                    <AdminDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/agent/*"
                element={
                  <PrivateRoute role={['agent', 'sub-agent']}>
                    <AgentDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/lead/new"
                element={
                  <PrivateRoute role={['agent', 'sub-agent']}>
                    <LeadForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="/payouts"
                element={
                  <PrivateRoute role={['admin', 'agent', 'sub-agent']}>
                    <PayoutDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sub-agent/new"
                element={
                  <PrivateRoute role="agent">
                    <CreateSubAgent />
                  </PrivateRoute>
                }
              />
              <Route path="/funds" element={<Funds />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/products" element={<Products />} />
            </Routes>
            <Footer />
          </Router>
        </ChakraProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
